import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";

import { getDb } from "./config";
import type { VipGroupInfo } from "./types";

export function vipGroupInfoDoc(userId: string) {
  return doc(getDb(), "users", userId, "meta", "vip-group-info");
}

export function useVipGroupInfo(userId: string | undefined, enabled = true) {
  const [info, setInfo] = useState<VipGroupInfo | null>(null);
  const [loading, setLoading] = useState(Boolean(enabled && userId));

  useEffect(() => {
    if (!enabled || !userId) {
      setInfo(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsub = onSnapshot(
      vipGroupInfoDoc(userId),
      (snap) => {
        setInfo(snap.exists() ? (snap.data() as VipGroupInfo) : null);
        setLoading(false);
      },
      () => {
        setInfo(null);
        setLoading(false);
      },
    );

    return () => unsub();
  }, [enabled, userId]);

  return { info, loading };
}

export function buildTelegramConnectUrl(token: string) {
  return `https://t.me/rc_vip_user_bot?start=${token}`;
}

export function isTelegramLinked(info: VipGroupInfo | null | undefined) {
  return Boolean(info?.telegramLinkedAt || info?.telegramUserId);
}
